import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

export interface PersonnelBasicInfo {
  account_id: string;
  age: number;
  birth_date: string;
  email: string;
  emp_num: string;
  experience: number;
  gender: string;
  is_head_nurse: boolean;
  joining_date: string;
  level_: string;
  name: string;
  nurse_id: string;
  phone_number: string;
  role: string;
  tenure: string;
  work_place: string;
  profile_image_url?: string;
}

/**
 * personnel-basic-info 데이터를 가져오는 커스텀 훅
 * @returns useQuery 결과
 */
export function usePersonnelBasicInfo() {
  return useQuery({
    queryKey: QUERY_KEYS.nurses.personnelBasicInfo(),
    queryFn: async () => {
      return await httpClient.get<PersonnelBasicInfo>(
        "/nurses/personnel-basic-info",
        {
          withCredentials: true,
        }
      );
    },
    staleTime: 1000 * 60 * 5, // 5분
  });
}
